import { ENABLE_CREDENTIALS_FOR_REQUEST } from '../Constants'

export default {
  mixins: [],
  data () {
    return {}
  },
  computed: {},
  methods: {
    requestOTP (input, provider) {
      const body = {
        number: input,
        provider: provider
      }

      return new Promise((resolve, reject) => {
        this.$beepAxios.post('/otp/new', body, { withCredentials: ENABLE_CREDENTIALS_FOR_REQUEST })
          .then(
            response => {
              resolve(response.data)
            },
            error => {
              this.$rollbar.error('Failed to request OTP', error)
              reject(error)
            }
          )
      })
    },

    verifyOTP (body) {
      return new Promise((resolve, reject) => {
        this.$beepAxios.post('/otp/verify', body, { withCredentials: ENABLE_CREDENTIALS_FOR_REQUEST })
          .then(
            response => {
              resolve(response.data)
            },
            error => {
              this.$rollbar.error('Failed to verify OTP', error)
              reject(error)
            }
          )
      })
    },

    logout () {
      return new Promise((resolve, reject) => {
        this.$beepAxios.delete('/otp/logout', { withCredentials: ENABLE_CREDENTIALS_FOR_REQUEST })
          .then(
            response => {
              resolve(response.data)
            },
            error => {
              this.$rollbar.error('Failed to logout', error)
              reject(error)
            }
          )
      })
    },

    getNumbers () {
      return new Promise((resolve, reject) => {
        this.$beepAxios.get('/otp/numbers', { withCredentials: ENABLE_CREDENTIALS_FOR_REQUEST })
          .then(
            response => {
              resolve(response.data)
            },
            error => {
              this.$rollbar.error('Failed to get numbers', error)
              reject(error)
            }
          )
      })
    },

    putNumbers (body) {
      return new Promise((resolve, reject) => {
        this.$beepAxios.put('/otp/numbers', body, { withCredentials: ENABLE_CREDENTIALS_FOR_REQUEST })
          .then(
            response => {
              resolve(response.data)
            },
            error => {
              this.$rollbar.error('Failed to update numbers', error)
              reject(error)
            }
          )
      })
    },

    // Healthcheck - hack-ish, will changed when time is friendlier
    /*
      Example response:
      ```
      { status: 0 }
      ```

      0 = down
      1 = up
    */
    getHealth () {
      return new Promise((resolve, reject) => {
        this.$beepAxios.get('/auth/healthcheck', { withCredentials: ENABLE_CREDENTIALS_FOR_REQUEST })
          .then(
            response => {
              resolve(response.data)
            },
            error => {
              reject(error)
            }
          )
      })
    },

    getProducts () {
      return new Promise((resolve, reject) => {
        this.$beepAxios.get('/products', { withCredentials: ENABLE_CREDENTIALS_FOR_REQUEST })
          .then(
            response => {
              resolve(response.data)
            },
            error => {
              this.$rollbar.error('Failed to fetch products', error)
              reject(error)
            }
          )
      })
    },

    getQuotas () {
      return new Promise((resolve, reject) => {
        this.$beepAxios.get('/products/quota', { withCredentials: ENABLE_CREDENTIALS_FOR_REQUEST })
          .then(
            response => {
              resolve(response.data)
            },
            error => {
              this.$rollbar.error('Failed to fetch quotas', error)
              reject(error)
            }
          )
      })
    },

    getCart () {
      return new Promise((resolve, reject) => {
        this.$beepAxios.get('/products/cart', { withCredentials: ENABLE_CREDENTIALS_FOR_REQUEST })
          .then(
            response => {
              resolve(response.data)
            },
            error => {
              this.$rollbar.error('Failed to fetch cart', error)
              reject(error)
            }
          )
      })
    },

    postCart () {
      return new Promise((resolve, reject) => {
        this.$beepAxios.post('/products/cart', {}, { withCredentials: ENABLE_CREDENTIALS_FOR_REQUEST })
          .then(
            response => {
              resolve(response.data)
            },
            error => {
              this.$rollbar.error('Failed to create cart', error)
              reject(error)
            }
          )
      })
    },

    putCart (body) {
      return new Promise((resolve, reject) => {
        this.$beepAxios.put('/products/cart', body, { withCredentials: ENABLE_CREDENTIALS_FOR_REQUEST })
          .then(
            response => {
              resolve(response.data)
            },
            error => {
              this.$rollbar.error('Failed to update cart', error)
              reject(error)
            }
          )
      })
    },

    getTransactionHistory () {
      return new Promise((resolve, reject) => {
        this.$beepAxios.get('/payments/history', { withCredentials: ENABLE_CREDENTIALS_FOR_REQUEST })
          .then(
            response => {
              resolve(response.data)
            },
            error => {
              this.$rollbar.error('Failed to get transaction history', error)
              reject(error)
            }
          )
      })
    },

    getReceipt (uuid, phone) {
      return new Promise((resolve, reject) => {
        this.$beepAxios.get(`/payments/deeplink/${uuid}/${phone}`, { withCredentials: false })
          .then(
            response => {
              resolve(response.data)
            },
            error => {
              this.$rollbar.error('Failed to get transaction receipt', error)
              reject(error)
            }
          )
      })
    },

    getPaymentMethods () {
      return new Promise((resolve, reject) => {
        this.$beepAxios.get('/payments', { withCredentials: ENABLE_CREDENTIALS_FOR_REQUEST })
          .then(
            response => {
              resolve(response.data)
            },
            error => {
              this.$rollbar.error('Failed to get payment methods', error)
              reject(error)
            }
          )
      })
    },

    postSelectedPaymentMethod (body) {
      return new Promise((resolve, reject) => {
        this.$beepAxios.post('/payments/new', body, { withCredentials: ENABLE_CREDENTIALS_FOR_REQUEST })
          .then(
            response => {
              resolve(response.data)
            },
            error => {
              this.$rollbar.error('Failed to create new payment', error)
              reject(error)
            }
          )
      })
    },

    putCancelTransaction (body) {
      return new Promise((resolve, reject) => {
        this.$beepAxios.post('/payments/cancel', body, { withCredentials: ENABLE_CREDENTIALS_FOR_REQUEST })
          .then(
            response => {
              resolve(response.data)
            },
            error => {
              this.$rollbar.error('Failed to cancel payment', error)
              reject(error)
            }
          )
      })
    },

    getPaymentStatus (body) {
      return new Promise((resolve, reject) => {
        this.$beepAxios.post('/payments/status', body, { withCredentials: ENABLE_CREDENTIALS_FOR_REQUEST })
          .then(
            response => {
              resolve(response.data)
            },
            error => {
              this.$rollbar.error('Failed to get payment status', error)
              reject(error)
            }
          )
      })
    },

    getPaylahUserInfo (body) {
      return new Promise((resolve, reject) => {
        this.$beepAxios.post('/otp/paylah_userinfo', body, { withCredentials: ENABLE_CREDENTIALS_FOR_REQUEST })
          .then(
            response => {
              resolve(response.data)
            },
            error => {
              this.$rollbar.error('Failed to fetch paylah userinfo', error)
              reject(error)
            }
          )
      })
    }
  }
}
